module.exports = __webpack_public_path__ + "media/images/ui-icons_454545_256x240-353f4412930b76882dc0787963036ba5.png";